
import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/components/headers/form-header/form-header.vue';

import InputCC from '@/components/inputs/text/cc_number.input.vue';
import InputPark from '@/components/inputs/options/park.input.vue';
import InputClientType from '@/components/inputs/options/client-type.input.vue';
import { IPark } from '@/models/IPark.model';
import { UsersAPI } from '@/apis/users.api';
import moment from 'moment';
import { BookingAPI } from '@/apis/bookings.api';
import { IBooking } from '@/models/IBooking.model';

@Component({
  components: {
    'form-header': FormHeader,
    'input-cc': InputCC,
    'input-park': InputPark,
    'input-client-type': InputClientType
  },
  computed: {

    StoreParks: function() {
      return this.$store.state.parks;
    },

    StoreClientType: function() {
      return this.$store.state.clientType;
    }

  }
})
export default class Home extends Vue {

  private cc: string = '';

  goToAcces(){
    this.$router.push({ 
      name: 'AccessView'
    });
  }
  
  private mounted() {
    const parkId = this.$route.params.parkId;
    const clientType = this.$route.params.clientType;
    
    if(parkId) this.$store.dispatch('setParkById',parkId)
    else this.$store.dispatch('fetchParks')

    if(clientType) this.$store.dispatch('setClientType',clientType)
    else this.$store.dispatch('setClientType','PUBLIC')


  }

  public async setCC($cc: string){
      this.cc = $cc;
  }

  public async doAccess(){

    const cc = this.cc;
    const park = this.$store.state.park;
    const parkId = (park.name || '').replace(/[^A-Z0-9]+/ig, "_")
    const clientType = this.$store.state.clientType;
    const date = this.$store.state.time.date;
    const hour = this.$store.state.time.hour;

    // PULL BOOKINGS FOR USER, PARK AND DATE=TODAY
    const ddmmyyyy = moment(date).format('DDMMYYYY');
    const parkName = park.name;

    const isReadyFetching = await this.$store.dispatch('fetchBookingByDateAndParkAndCC', { ddmmyyyy, parkName, cc });
    const bookings:IBooking[] = this.$store.state.bookings.filter(
      (booking: IBooking) => 
        booking.ddmmyyyy === ddmmyyyy && 
        booking.cc_number === cc && 
        booking.parkName === park.name
    );

    if(bookings.length > 0){
      const bookingId =  bookings[0].id;
      this.$router.push({ 
        name: 'CheckView', 
        params: { bookingId: bookingId } 
      });
    } else {
      this.$swal('NO HAY RESERVAS', '', 'error') 
    }

  }
}